import React from 'react';
import styles from './UnderConstructionPage.module.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const UnderConstructionPage = () => {
    return (
        <>
            <Header />
            <div className={styles.container}>
                <div className={styles.content}>
                    <h1 className={styles.title}>🚧 Still Under Construction 🚧</h1>
                    <p className={styles.message}>
                        We're working hard to bring this page to life. Please check back soon!
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default UnderConstructionPage; 